import React from 'react';

import clsx from 'clsx';
import { CollectionType } from '@/@types';
import * as styles from './collection-logo.styles';
import { Image } from '../../atoms';

const CollectionLogo: React.FC<{
  collection?: CollectionType;
  size?: number | string;
  style?: React.CSSProperties;
  className?: string;
  color?: string;
}> = ({ collection, size = 100, style, color, className }) => {
  const calculatedStyle = { ...style, '--size': `${typeof size === 'number' ? `${size}px` : size}`, '--color': color } as React.CSSProperties;
  const filteredMedia = collection?.media?.map((val) => {
    return val.type === 'image' ? val.source : undefined;
  });
  const styleVariables = [...Array(3).keys()].map((index) => {
    const image = filteredMedia?.[index] || collection?.images?.[index];

    return image ? ({ '--image': `url(${Image.getURL(image, Number(size), 75)})` } as React.CSSProperties) : undefined;
  });

  return (
    <div className={clsx(styles.container, className)} style={calculatedStyle}>
      <div className={clsx(styles.col1, styles.cell)} style={styleVariables[0]} />
      <div className={clsx(styles.row1, styles.cell)} style={styleVariables[1]} />
      <div className={clsx(styles.row2, styles.cell)} style={styleVariables[2]} />
    </div>
  );
};

export default CollectionLogo;
